import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ClientStatementRepositoryService extends BaseRepositoryService<
  ModelRegistry['client-statement']
> {
  recordName = 'client-statement';
  implementMethods = ['findRecord', 'findAll', 'query'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/client-statement': ClientStatementRepositoryService;
  }
}
